import React from 'react';
import {IVideoAvatar} from 'redux/auth/interfaces';

import './styles.scss';

const MAX_VISIBLE_LANGUAGES = 3;

interface IAvatarDetailsProps {
  avatar: IVideoAvatar;
  isSelected?: boolean;
  onSelect?: () => void;
}

export const VideoAvatarDetails = React.forwardRef<HTMLButtonElement, IAvatarDetailsProps>(
  ({avatar, isSelected = false, onSelect}, ref) => {
    const visibleLanguages = avatar.languages?.slice(0, MAX_VISIBLE_LANGUAGES) ?? [];
    const remainingCount = Math.max(0, (avatar.languages?.length ?? 0) - MAX_VISIBLE_LANGUAGES);

    return (
      <div
        className={`video-avatar-details${isSelected ? ' video-avatar-details--selected' : ''}`}
        role="option"
        aria-selected={isSelected}
      >
        <button
          ref={ref}
          className="video-avatar-details__icon"
          onClick={onSelect}
          aria-label={`${avatar.name}${isSelected ? ' (selected)' : ''}`}
        >
          <img
            className="video-avatar-details__img"
            src={avatar.fileUrl}
            alt={avatar.name}
            onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
          />
        </button>
        <div className="video-avatar-details__name">{avatar.name}</div>
        {avatar.description && (
          <div className="video-avatar-details__description">{avatar.description}</div>
        )}
        {visibleLanguages.length > 0 && (
          <div className="video-avatar-details__languages" aria-label="Supported languages">
            {visibleLanguages.map(lang => (
              <span key={lang} className="video-avatar-details__lang-tag">{lang}</span>
            ))}
            {remainingCount > 0 && (
              <span className="video-avatar-details__lang-tag video-avatar-details__lang-tag--more">
                +{remainingCount}
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
);

VideoAvatarDetails.displayName = 'VideoAvatarDetails';
